import { __assign, __extends, __rest } from "tslib";
// @flow
import * as React from 'react';
import CheckBoxOutlineBlankIcon from '../internal/svg-icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '../internal/svg-icons/CheckBox';
import Icon from '../Icon';
import StyleInput from './StyleInput';
import ToggleButton from './ToggleButton';
var SwitchBase = /** @class */ (function (_super) {
    __extends(SwitchBase, _super);
    function SwitchBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleInputChange = function (event) {
            var checked = event.target.checked;
            if (_this.props.readOnly) {
                return;
            }
            if (!_this.isControlled) {
                _this.setState({ checked: checked });
            }
            if (_this.props.onChange) {
                _this.props.onChange(event, checked);
            }
        };
        _this.handleFocus = function (event) {
            if (_this.props.readOnly) {
                return;
            }
            if (_this.ripple) {
                _this.ripple.handleFocus(event);
            }
        };
        _this.handleBlur = function (event) {
            if (_this.props.readOnly) {
                return;
            }
            if (_this.ripple) {
                _this.ripple.handleBlur(event);
            }
        };
        return _this;
    }
    SwitchBase.prototype.componentWillMount = function () {
        var props = this.props;
        this.isControlled = props.checked != null;
        if (!this.isControlled) {
            // not controlled, use internal state
            this.setState({
                checked: props.defaultChecked !== undefined ? props.defaultChecked : false,
            });
        }
    };
    SwitchBase.prototype.render = function () {
        var _a = this.props, checkedProp = _a.checked, checkedIcon = _a.checkedIcon, disabledProp = _a.disabled, iconProp = _a.icon, inputProps = _a.inputProps, inputRef = _a.inputRef, _b = _a.inputType, inputType = _b === void 0 ? 'checkbox' : _b, name = _a.name, onChange = _a.onChange, tabIndex = _a.tabIndex, value = _a.value, readOnlyProp = _a.readOnly, other = __rest(_a, ["checked", "checkedIcon", "disabled", "icon", "inputProps", "inputRef", "inputType", "name", "onChange", "tabIndex", "value", "readOnly"]);
        var checked = this.isControlled ? checkedProp : this.state.checked;
        var icon = checked ? checkedIcon : iconProp;
        if (typeof icon === 'string') {
            icon = React.createElement(Icon, null, icon);
        }
        return (React.createElement(ToggleButton, __assign({ component: "span", checked: checked, disabled: disabledProp || readOnlyProp }, other),
            icon,
            React.createElement(StyleInput, __assign({ type: inputType, name: name, checked: this.isControlled ? checkedProp : undefined, onChange: this.handleInputChange, disabled: disabledProp, readOnly: readOnlyProp, tabIndex: tabIndex, value: value, ref: inputRef }, inputProps, { onFocus: this.handleFocus, onBlur: this.handleBlur }))));
    };
    SwitchBase.defaultProps = {
        checkedIcon: React.createElement(CheckBoxIcon, null),
        icon: React.createElement(CheckBoxOutlineBlankIcon, null),
        inputType: 'checkbox',
    };
    return SwitchBase;
}(React.Component));
export default SwitchBase;
//# sourceMappingURL=SwitchBase.js.map